import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("a", {
  name: "details",
  id: "details"
}, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "row mt-3" }
const _hoisted_5 = { class: "col-sm-8 pl-0" }
const _hoisted_6 = { class: "col-sm-4" }
const _hoisted_7 = {
  key: 0,
  class: "activityMetaLabel"
}
const _hoisted_8 = { class: "activityAdditionalInfo" }
const _hoisted_9 = {
  key: 1,
  class: "row showtimes"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "When")
], -1)
const _hoisted_11 = { class: "col-sm-10" }
const _hoisted_12 = {
  key: 0,
  class: "activityMetaLabel"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 2,
  class: "activityMetaLabel"
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right" }, null, -1)
const _hoisted_18 = { class: "mt-5 w-100 text-center mobile-only" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("em", null, "Back to times", -1)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.activity.thumbnailImageUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.activity.thumbnailImageUrl,
            alt: _ctx.activity.displayName,
            class: "img-max"
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.activity.displayName), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.activity.duration)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Duration"))
          : _createCommentVNode("", true),
        _createTextVNode(),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.activity.duration), 1)
      ])
    ]),
    (_ctx.schedule.schedules && _ctx.schedule.schedules.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schedule.schedules, (timeSchedule) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "mr-3",
                key: timeSchedule.sortKey
              }, [
                (timeSchedule.prependText)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(timeSchedule.prependText), 1))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(timeSchedule.displayStart) + " ", 1),
                (timeSchedule.displayEnd)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "— " + _toDisplayString(timeSchedule.displayEnd), 1))
                  : _createCommentVNode("", true),
                _createTextVNode(),
                (timeSchedule.appendText)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(timeSchedule.appendText), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("p", {
      innerHTML: _ctx.activity.shortDescription
    }, null, 8, _hoisted_15),
    _createElementVNode("div", null, [
      _createElementVNode("a", {
        href: _ctx.activity.activityUrl
      }, [
        _createTextVNode(_toDisplayString(_ctx.moreDetailsCTA) + " ", 1),
        _hoisted_17
      ], 8, _hoisted_16)
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.backToTimes())),
        style: {"color":"#4a4a4a","text-decoration":"underline","font-weight":"normal"}
      }, _hoisted_20)
    ])
  ], 64))
}